import style from "./00_tcp.css"
import Header from '../components/header'
import Footer from '../components/footer'

export default function HITTeacher() {
    return (
    <div style={{ backgroundColor: "#FFFDF4", minHeight: "100vh" }}>
        <Header />
            <div class="legal-document">
<h1>How It Works — Teachers</h1>

<p>SurSaathi gives music teachers an opportunity to create a profile and be discovered by students, parents, and guardians looking for music lessons.</p>

<p>Our role is primarily to facilitate <strong>teacher discovery and initial contact</strong>. The teaching relationship itself is between you and the student or their parent/guardian.</p>

<h2>1. Create Your Teacher Profile</h2>

<p>To be listed on SurSaathi, you may be asked to provide information such as:</p>

<ul>
  <li>Your name</li>
  <li>Instruments or subjects you teach</li>
  <li>Teaching experience</li>
  <li>Qualifications or professional information</li>
  <li>General location</li>
  <li>Availability</li>
  <li>Profile photograph</li>
  <li>Contact information</li>
  <li>Other information relevant to your teacher profile</li>
</ul>

<p>Please make sure that the information you provide is truthful, accurate, current, lawful, and not misleading.</p>

<h2>2. Your Profile May Be Public</h2>

<p>Some information from your teacher profile may be displayed publicly so that students and parents/guardians can discover you.</p>

<p>This may include information such as your:</p>

<ul>
  <li>Name</li>
  <li>Instruments or subjects taught</li>
  <li>General location</li>
  <li>Teaching experience</li>
  <li>Qualifications or professional information</li>
  <li>Availability</li>
  <li>Profile information or photograph</li>
</ul>

<p>Please do not submit private information that you do not want displayed publicly.</p>

<h2>3. Students Can Find You</h2>

<p>Students, parents, or guardians may discover your profile when looking for a music teacher.</p>

<p>They may request information about you or contact you through a SurSaathi feature.</p>

<p>Depending on the circumstances, SurSaathi may provide relevant information from the student's request to you so that you can respond.</p>

<p>We may also provide relevant information about you to the student or parent/guardian for the purpose of facilitating the requested connection.</p>

<h2>4. What Information May Be Shared?</h2>

<p>The information shared depends on the circumstances and the purpose of the enquiry.</p>

<p>It may include relevant information such as:</p>

<ul>
  <li>Name</li>
  <li>Contact details</li>
  <li>General location</li>
  <li>Instrument or subject</li>
  <li>Teaching requirements or preferences</li>
  <li>Information contained in the student's request</li>
  <li>Other information reasonably necessary to facilitate the connection</li>
</ul>

<p>Once contact details have been shared, you may communicate directly with the student or their parent/guardian.</p>

<p>You should use information obtained through SurSaathi only for legitimate purposes connected with the relevant enquiry or teaching relationship.</p>

<h2>5. What Happens After You Connect With a Student?</h2>

<p>Once you and the student or parent/guardian are able to communicate directly, you decide the teaching arrangement together.</p>

<p>You should clearly discuss and agree on:</p>

<ul>
  <li>Lesson fees</li>
  <li>Payment method</li>
  <li>Lesson frequency</li>
  <li>Lesson duration</li>
  <li>Online or in-person lessons</li>
  <li>Lesson location</li>
  <li>Trial lessons</li>
  <li>Cancellation and rescheduling</li>
  <li>Transportation arrangements</li>
  <li>Instruments and equipment</li>
  <li>Practice requirements</li>
  <li>Communication methods</li>
  <li>Refund arrangements</li>
  <li>Any other relevant terms</li>
</ul>

<p>SurSaathi does not set your lesson fees, supervise your lessons, guarantee payment, or become a party to your agreement with the student unless we expressly agree otherwise in writing.</p>

<h2>6. How Do You Get Paid?</h2>

<p>Unless SurSaathi expressly provides a separate payment service, <strong>payment for lessons is arranged directly between you and the student or hiring organisation.</strong></p>

<p>You and the student should agree on the amount, payment method, timing, cancellation terms, and any refund arrangements before lessons begin.</p>

<p>SurSaathi is not responsible for unpaid fees, payment disputes, refunds, chargebacks, or fraudulent transactions between users, except where liability cannot legally be excluded.</p>

<h2>7. Does SurSaathi Verify Teachers?</h2>

<p>SurSaathi may review information submitted by teachers, but we are not required to conduct comprehensive verification.</p>

<p>Any verification we perform should not be treated as:</p>

<ul>
  <li>A comprehensive background check</li>
  <li>Professional certification</li>
  <li>Police verification</li>
  <li>Safeguarding certification</li>
  <li>A guarantee of identity</li>
  <li>A guarantee of future conduct</li>
</ul>

<p>Unless expressly stated otherwise, users should understand that teacher information is primarily information submitted by the teacher.</p>

<p>You are responsible for providing truthful information and should not submit false qualifications, identities, experience, references, photographs, or other misleading information.</p>

<h2>8. Professional Conduct</h2>

<p>Teachers are expected to maintain appropriate and respectful professional boundaries.</p>

<p>You must not use information obtained through SurSaathi to:</p>

<ul>
  <li>Harass or threaten a student.</li>
  <li>Stalk or exploit another person.</li>
  <li>Sexually harass or exploit another person.</li>
  <li>Groom or exploit a minor.</li>
  <li>Pressure someone into an unwanted relationship or activity.</li>
  <li>Request inappropriate photographs or videos.</li>
  <li>Misuse or distribute another person's private information.</li>
  <li>Engage in discriminatory abuse.</li>
  <li>Engage in fraud or financial deception.</li>
  <li>Facilitate unlawful activity.</li>
</ul>

<p>You should also avoid requesting unnecessary sensitive personal information from students.</p>

<h2>9. Additional Care When Teaching Minors</h2>

<p>If you are communicating with or teaching a minor, exercise additional care.</p>

<p>Where appropriate:</p>

<ul>
  <li>Communicate with the parent or legal guardian.</li>
  <li>Maintain clear professional boundaries.</li>
  <li>Avoid inappropriate private or personal communications with minors.</li>
  <li>Choose safe and appropriate locations for in-person lessons.</li>
  <li>Follow appropriate supervision arrangements.</li>
  <li>Do not request inappropriate photographs, videos, or personal information.</li>
</ul>

<p>Teachers are independently responsible for their professional conduct and for complying with laws and regulations applicable to their activities.</p>

<h2>10. Safety for In-Person Lessons</h2>

<p>If you arrange an in-person lesson, you and the student or parent/guardian are responsible for deciding whether the location and circumstances are safe and appropriate.</p>

<p>Consider:</p>

<ul>
  <li>Using an appropriate location.</li>
  <li>Avoiding isolated or unsafe places.</li>
  <li>Clearly agreeing on the lesson location beforehand.</li>
  <li>Taking appropriate precautions when meeting someone for the first time.</li>
  <li>Communicating with a parent or guardian when the student is a minor.</li>
</ul>

<p>SurSaathi does not select, inspect, supervise, or guarantee the safety of physical locations used for lessons.</p>

<h2>11. Safety for Online Lessons</h2>

<p>For online lessons, you and the student are responsible for taking reasonable precautions concerning:</p>

<ul>
  <li>The online platform being used</li>
  <li>Account security</li>
  <li>Passwords and authentication</li>
  <li>Screen sharing</li>
  <li>Recording</li>
  <li>Camera and microphone access</li>
  <li>Personal information visible in the background</li>
  <li>Links shared during communications</li>
  <li>Information exchanged during lessons</li>
</ul>

<p>Never request or share passwords, OTPs, banking credentials, or other sensitive authentication information.</p>

<h2>12. What If a Student Doesn't Respond?</h2>

<p>Students may not always respond to a teacher's message or enquiry.</p>

<p>For example, a student may:</p>

<ul>
  <li>Already have found another teacher.</li>
  <li>Decide that another teacher is more suitable.</li>
  <li>Not be checking their messages.</li>
  <li>Decide not to proceed with lessons.</li>
  <li>Simply choose not to respond.</li>
</ul>

<p>SurSaathi does not guarantee that a student will respond, accept an arrangement, attend lessons, make payment, or remain available.</p>

<h2>13. Can SurSaathi Remove a Teacher Listing?</h2>

<p>Yes.</p>

<p>SurSaathi may, subject to applicable law:</p>

<ul>
  <li>Refuse to publish a listing.</li>
  <li>Request additional information.</li>
  <li>Edit or correct information.</li>
  <li>Temporarily suspend a listing.</li>
  <li>Permanently remove a listing.</li>
  <li>Restrict access to the Website.</li>
  <li>Investigate suspected misuse.</li>
  <li>Take other reasonable action where there is a safety, legal, security, fraud, reputational, or policy concern.</li>
</ul>

<p>Removal of a listing does not necessarily mean that SurSaathi has determined that the teacher committed wrongdoing.</p>

<h2>14. What Is SurSaathi's Role?</h2>

<p>SurSaathi's primary role is to help students and teachers discover one another and facilitate initial communication.</p>

<p>We do not:</p>

<ul>
  <li>Employ teachers merely because they are listed.</li>
  <li>Act as an agent or representative of teachers or students.</li>
  <li>Arrange or supervise lessons.</li>
  <li>Set or collect lesson fees.</li>
  <li>Guarantee payment.</li>
  <li>Guarantee attendance or punctuality.</li>
  <li>Determine lesson locations.</li>
  <li>Monitor private communications.</li>
  <li>Supervise teachers or students.</li>
  <li>Provide childcare or guardianship.</li>
  <li>Guarantee the safety of meetings or lessons.</li>
  <li>Guarantee teaching quality or results.</li>
  <li>Resolve private disputes between teachers and students.</li>
</ul>

<p>Once contact is facilitated, the relationship between you and the student or parent/guardian is independent of SurSaathi.</p>

<h2>15. Have a Concern?</h2>

<p>You can contact SurSaathi if you become aware of:</p>

<ul>
  <li>Suspected false qualifications</li>
  <li>Fake identities</li>
  <li>Fraudulent activity</li>
  <li>Harassment</li>
  <li>Threatening behaviour</li>
  <li>Inappropriate conduct</li>
  <li>Suspected exploitation of minors</li>
  <li>Misuse of personal information</li>
  <li>Spam</li>
  <li>Attempts to misuse the Website</li>
  <li>Other conduct that may violate our Terms or policies</li>
</ul>

<p>Where appropriate, SurSaathi may review the available information and take reasonable action.</p>

<p>If there is an immediate threat to life, physical safety, child protection, or other serious criminal conduct, contact the appropriate emergency, law-enforcement, child-protection, or other competent authority.</p>

<p><strong>SurSaathi helps you reach potential students. The teaching relationship, fees, lessons, payments, and conduct are ultimately your responsibility and the responsibility of the student or their parent/guardian.</strong></p>
            </div>
        <Footer />
    </div>
  );
}